import React from 'react';
import {useStoreon} from 'storeon/react';
import {useMediaQuery} from 'react-responsive';
import {GxButton, GxIcon} from '@garpix/garpix-web-components-react';
import { Events, State } from '@/interfaces';
import styles from './styles/index.module.scss';
import MenuIconSVG from '../../assets/icons/menuIcon.svg';

const Burger = () => {
  const {dispatch, flagSidebar} = useStoreon<State, Events>('certificatesParamsApi','flagSidebar');
  const isDesktopOrMobile = useMediaQuery({
    query: '(max-width: 568px)'
  });
    return (
      <>
        {isDesktopOrMobile &&
          <GxButton
            className={styles['btn--open']}
            onClick={() => dispatch('changeSidebar', !flagSidebar)}
          >
            <GxIcon className={styles['icon']} src={MenuIconSVG} />
          </GxButton>
        }
      </>
    );
};

export default Burger;